// Custom validation messages for number fields
// Usage: Add data-custom-validity="Your message" attribute to input fields

document.addEventListener('DOMContentLoaded', function() {
  initCustomValidation();
});

// Re-initialize when new elements are added (for cocoon nested forms)
document.addEventListener('cocoon:after-insert', function() {
  initCustomValidation();
});

function initCustomValidation() {
  const inputs = document.querySelectorAll('input[data-custom-validity]:not([data-validation-initialized])');

  inputs.forEach(function(input) {
    const customMessage = input.dataset.customValidity;

    input.addEventListener('invalid', function() {
      this.setCustomValidity(customMessage);
    });

    input.addEventListener('input', function() {
      if (this.validity.valid) {
        this.setCustomValidity('');
      }
    });

    // Mark as initialized to prevent duplicate event listeners
    input.setAttribute('data-validation-initialized', 'true');
  });
}
